import { CellData, NO_DATA_CELL, ProgressBar } from './ProgressBar';
import {
  formatDateMMddYYYY,
  MetricProgressBar,
  toProgressSegments,
} from '../utils/utils';
import {
  ProgressPortraitMetrics,
  VinelandAssessment,
} from '../model/ProgressPortrait';
import { CellTooltip, TooltipItem } from './CellTooltip';

const vinelandExtractor = (progressPortraitMetrics: ProgressPortraitMetrics) =>
  progressPortraitMetrics.vinelands ?? [];

const toCellData = (metricData: VinelandAssessment): CellData => {
  const level = metricData.ABC_Adaptive_Level__c;
  const date = metricData.vineland_Assessment_Date__c;
  if ((!level && !date) || level === 'N/A') {
    return NO_DATA_CELL;
  }
  const tooltip = <DevelopmentMilestoneTooltip vineland={metricData} />;
  if (level === 'Low') {
    return {
      label: 'Low',
      level: 'low',
      tooltip,
    };
  }
  if (level === 'Moderately Low') {
    return {
      label: 'Moderately Low',
      level: 'medium',
      tooltip,
    };
  }
  return {
    label: 'Adequate or above',
    level: 'high',
    tooltip,
  };
};

export const DevelopmentMilestoneMetric = ({
  progressPortraitMetrics,
}: MetricProgressBar) => {
  const segments = toProgressSegments(
    progressPortraitMetrics,
    vinelandExtractor,
    toCellData,
  );
  return <ProgressBar segments={segments} />;
};

const DevelopmentMilestoneTooltip = ({
  vineland,
}: {
  vineland: VinelandAssessment;
}) => {
  const info: TooltipItem[] = [
    {
      label: 'Vineland-3 Date:',
      value: formatDateMMddYYYY(vineland.vineland_Assessment_Date__c),
    },
    {
      label: 'Adaptive Behavior Composite:',
      value: `${vineland.ABC_Score__c} (${vineland.ABC_Adaptive_Level__c})`,
    },
    {
      label: 'Respondent:',
      value: vineland.name_Of_Respondent__c,
    },
  ];
  return <CellTooltip info={info} />;
};
